module.exports = __webpack_public_path__ + "img/backgroundImg2.beb54d5.png";